import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BottomSheetControlsComponent } from 'src/app/bottom-sheet-controls/bottom-sheet-controls.component';
import { BottomSheetTitleComponent } from 'src/app/components/bottom-sheet-title/bottom-sheet-title.component';
import { AuthService } from 'src/services/auth/auth.service';
import { TagService } from 'src/services/tag/tag.service';
import { ProBadgeComponent } from '../../app/components/pro-badge/pro-badge.component';

@Component({
  selector: 'create-tag-bottom-sheet',
  standalone: true,
  imports: [
    BottomSheetControlsComponent,
    FormsModule,
    BottomSheetTitleComponent,
    MatInputModule,
    MatFormFieldModule,
    CommonModule,
    ProBadgeComponent,
  ],
  templateUrl: './create-tag-bottom-sheet.component.html',
  styleUrl: './create-tag-bottom-sheet.component.scss',
})
export class CreateTagBottomSheetComponent implements AfterViewInit {
  fullPath = '';
  isPeriodic = false;
  isSubmitting = false;

  tagsLength: number | undefined; // TODO: should be input

  @ViewChild('myInput') input: ElementRef | undefined;

  public _bottomSheetRef =
    inject<MatBottomSheetRef<CreateTagBottomSheetComponent>>(MatBottomSheetRef);

  constructor(
    private tagService: TagService,
    private _snackBar: MatSnackBar,
    public authService: AuthService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { tagsLength: number }
  ) {
    this.tagsLength = data.tagsLength;
  }

  ngAfterViewInit(): void {
    this.isSubmitting = false;
    setTimeout(() => {
      if (this.input) {
        this.input.nativeElement.focus();
      }
    }, 0);
  }

  async createTag() {
    if (this.isPeriodic && !this.authService.isPro) {
      this._bottomSheetRef.dismiss({
        newFullPath: null,
        shouldOpenSettingsForPrefundPro: true,
      });
    } else if (!!this.fullPath) {
      this.isSubmitting = true;

      await this.tagService.create(this.fullPath, this.isPeriodic);
      this._bottomSheetRef.dismiss({
        newFullPath: this.fullPath,
        shouldOpenSettingsForPrefundPro: false,
      });
    } else {
      this._snackBar.open('Please enter a name', 'Close');
    }
  }

  updateName(_fullPath: string, event: Event) {
    const target = event.target as HTMLInputElement;
    const newPath = target.value.replace(' ', '-').toLowerCase();
    this.fullPath = newPath;
  }
}
